// Demo-mode flag. When the URL has ?demo=1, the app suppresses
// dev-only UI (Example-data banner, pre-chat PHI modal) and swaps
// the e2e seed identity for a presentable "Mary Bennett" so the
// App Store / marketing capture tool can render real screens.
//
// Read at render time, never persisted. CLAUDE.md forbids localStorage
// and sessionStorage. The capture tool appends ?demo=1 to every URL it
// visits so the flag survives navigation.

export function useDemoMode(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('demo') === '1';
}

export const DEMO_DISPLAY_NAME = 'Mary Bennett';
export const DEMO_DISPLAY_EMAIL = 'mary.bennett@example.com';

const E2E_EMAIL_PATTERN = /^e2e-test@|^demo@|^test@/i;

export function isE2EIdentity(email: string | null | undefined): boolean {
  if (!email) return false;
  return E2E_EMAIL_PATTERN.test(email);
}
